import IntervenerCreateForm from '@/components/AccountConfig/IntervenerCreateForm/index.vue';
import { isMinor } from '../Interveners/roles_logic';

export default {
    name: 'Interveners',
    props: ['uuid', 'status', 'accountType'],

    components: {
        IntervenerCreateForm
    },

    data() {
        return {
            account: null,
            editable: '',
            uuidAccount: '',
            isAccountValidated: false,
            rolesOptions: [],
            interveners: [],
            pendingInterveners: []
        };
    },

    async mounted() {
        this.uuidAccount = this.uuid;
        this.isAccountValidated = this.status === 'VALIDATED' ? true : false;
        this.loadRoles();
        await this.loadAccountData(this.uuidAccount);
    },

    computed: {
        intervenerAddType() {
            const isMinor = this.interveners.find(intervener => {
                return (
                    intervener.isMinor &&
                    intervener.account_intervener_role.find(
                        role => role.key === 'TITULAR' || role.key === 'NUDO_PROPIETARIO'
                    )
                );
            });
            const isJuridical = this.interveners.find(
                intervener => intervener.intervener_type === 'J'
            );
            let type;

            if (isJuridical) type = 'JURIDICAL_ACCOUNT';
            else if (isMinor) type = 'PHYSICAL_ACCOUNT_TUTOR';
            else type = 'PHYSICAL_ACCOUNT';

            return type;
        },

        canEdit() {
            return this.status === 'FINALIZED';
        }
    },

    methods: {
        edit(index) {
            if (index === 'new') {
                this.editable = 'new';
            } else {
                this.editable = index;
            }
        },
        cancel() {
            this.editable = null;
            this.loadIntervenersData();
        },

        // Get i18n roles options
        loadRoles() {
            const roles = this.$t(`intervenerRoles.${this.accountType}`);

            this.rolesOptions = Object.entries(roles).map(item => {
                return { key: item[0], name: item[1] };
            });
        },

        async loadAccountData(uuidAccount) {
            const response = await this.$accountService.getAccount(null, uuidAccount);
            this.account = response.data.account;
        },

        loadIntervenersData() {
            let intervenersList = [];
            let pendingIntervenersList = [];

            // show account draft data is present.
            this.$accountService
                .getAccount({}, this.uuidAccount)
                .then(response => {
                    if (response.data.account.draft_data) {
                        const keys = Object.entries(response.data.account.draft_data);
                        const newInterveners = keys.filter(
                            key =>
                                key[0].startsWith('new_intervener') ||
                                key[0].startsWith('registered_intervener')
                        );
                        newInterveners.map(intervener => {
                            pendingIntervenersList.push(intervener.flat()[1]);
                        });
                        this.pendingInterveners = pendingIntervenersList;
                    }
                })
                .catch(error => console.error(error));

            // Get interveners
            this.$accountService
                .getAccountInterveners({}, this.uuidAccount)
                .then(response => {
                    response.data.accounts_intervener.map(intervener => {
                        intervener.isMinor = isMinor(intervener);
                        intervener.account_intervener_role.map(role => {
                            if (role === 'TITULAR') {
                                intervener.isTitular = true;
                            }
                            return role;
                        });
                        intervenersList.push(intervener);
                    });

                    // Interveners array without beneficiaries
                    this.interveners = intervenersList;

                    this.setIntervenerRoles();
                })
                .catch(error => console.error(error));
        },

        onFinishIntervenerCreation() {
            this.editable = false;
            this.loadIntervenersData();
            this.$bvToast.toast('Se ha actualizado correctamente', {
                title: 'Actualizado',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 10000,
                variant: 'success'
            });
        },

        // Set intervener roles to key-value objects to show and edit them
        setIntervenerRoles() {
            let intervenerMappedRoles = [];

            this.interveners.map(intervener => {
                intervenerMappedRoles = [];

                intervener.account_intervener_role.map(intervenerRole => {
                    this.rolesOptions.map(role => {
                        if (intervenerRole === role.key) {
                            intervenerMappedRoles.push(role);
                        }
                    });
                });

                intervener.account_intervener_role = intervenerMappedRoles;
            });
        }
    }
};
